import InputLloodText from '../InputLloodText'
import InputLloodTextarea from '../InputLloodTextarea'
import InputLloodTimePicker from '../InputLloodTimePicker'
import InputLloodDatePicker from '../InputLloodDatePicker'
import InputLloodCheckbox from '../InputLloodCheckbox'
import InputLloodHidden from '../InputLloodHidden'
import numberVariations from './numberVariations'
import selectVariations from './selectVariations'
import inputExtend from './inputExtend'


/*
TEST HOOKS
const textprueba = inputExtend(InputLloodText, [{
	hook: 'input',
	callback: function (comp, val) {
		return val + ' prueba test'
	}
}], {});
*/

const inputs = {
	textarea: InputLloodTextarea,
	checkbox: InputLloodCheckbox,
	text: InputLloodText,
	timepicker: InputLloodTimePicker,
	datepicker: InputLloodDatePicker,
	hidden: InputLloodHidden,
	...numberVariations,
	...selectVariations
}

export default Object.keys(inputs).reduce((o, k) => {

	const iName = `l-${k}`

	o[iName] = inputs[k]

	if (!o[iName].methods) o[iName].methods = {}

	return o

}, {})
